import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import { ReactNode } from 'react';

export type HeaderItem = {
  label: string;
  value: ReactNode;
};

type Props = {
  title: string;
  items: HeaderItem[];
};

export const Header = ({ title, items }: Props) => {
  return (
    <Card>
      <CardHeader title={title} sx={{ pb: 0 }} />
      <CardContent>
        {items.map((i, index) => (
          <Box key={index} sx={{ mb: 1, overflow: 'hidden' }}>
            <Typography fontWeight="bold" sx={{ pr: 1.5, display: 'inline-block', float: 'left' }}>
              {i.label}
            </Typography>
            <Box sx={{ display: 'inline-block', float: 'left' }}>{typeof i.value === 'function' ? i.value : <Typography>{i.value}</Typography>}</Box>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};
